import React, { useReducer, useState, useEffect, useRef, useMemo } from 'react'
import { Breadcrumb, BreadcrumbItem, Button, TileGroup, RadioTile, Tag, Tabs, Tab } from 'carbon-components-react';
import { FilterEdit32, Close32, User32 } from '@carbon/icons-react';
import { Navbar, Nav, Col, Container, Row } from 'react-bootstrap';
import "bootstrap/dist/css/bootstrap.min.css";
import SlidingPanel from "react-sliding-side-panel";
import "react-sliding-side-panel/lib/index.css";

import TimeFilter from '../ManageAutomationPage/Alerts/TimeFilter';
import moment from 'moment';
import DashboardFilters from './DashboardFilters';
import callGetApi from "../../requests/GetRequests";
import * as Constants from '../../requests/URLConstants';
import { getNewTimeRange } from '../ManageAutomationPage/Alerts/TimeFilterUtil';
import callPostApi from "../../requests/PostRequests";
import ExecutionPerformance from './ExecutionPerformanceDashboard/ExecutionPerformance';
import IncidentManagement from './IncidentManagementDashboard/IncidentManagement';
import SLACompliance from './SLADashboard/SLACompliance';
import QueueEfficiency from './QueuePerformanceDashboard/QueuePerformance';
import AlertManagement from './AlertManagementDashboard/AlertManagement';
import QueueManagement from './QueueManagementDashboard/QueueManagement';
import CapacityManagement from './CapacityManagementDashboard/CapacityManagement';
import UllCapacityManagement from './CapacityManagementDashboard/UllCapacityManagement';
import SchedulingEfficiency from './SchedulingEfficiencyDashboard/SchedulingEfficiency';
import Remediation from './RemediationDashboard/Remediation';
import BotPerformance from './BotPerformance/BotPerformance';
import AutomationTrustIndex from './AutomationTrustIndexDashboard/AutomationTrustIndex';
import Juniper from './JuniperDashboard/Juniper';
import ProductivityMetrics from './ProductivityMetricsDashboard/ProductivityMetrics';
import AutomationSchedulingEfficiency from './AutomationSchedulingEfficiency/AutomationSchedulingEfficiency';
import * as config from "../../config/Constants";
import dashboardAccessConfig from "./config/dashboardAccessConfig";
import dashboardAccessConfigUll from "./config/dashboardAccessConfigUll";
import BusinessViewValueRealization from './BusinessView/BusinessViewValueRealization';
import BpmnDiagram from '../Bpmn/BpmnDiagram';
import * as DashboardConstants from './DashboardConstants';
import ULLAutomationTrustIndex from './AutomationTrustIndexDashboard/ULLAutomationTrustIndex';
import AutomationBusiness from './AutomationBusinessCatalogue/AutomationBusiness';
import BotPerformanceULL from './BotPerformance/BotPerformanceULL';
import UsageStats from './UsageStatsDashboard/UsageStats';
import Processes from './ProcessesDashboard/Processes';
import Lens from './Lens'
import HeaderTiles from './HeaderTiles'
import OutsideClickHandler from 'react-outside-click-handler';
import UserLoginStatistics from './UserLoginStatistics/UserLoginStatistics';
import BatchJobStatistics from './BatchJobStatistics/BatchJobsStatistics';
import IntegrationStatistics from './IntegrationStatistics/IntegrationStatistics';
import AbandonedProcesses from './AbandonedProcesses/AbandonedProcesses';
import * as workspaces from '../../config/WorkspaceConstants'


require("./_header-panel-new.scss");

const HeaderPanel = (props) => {

    let roles = JSON.parse(localStorage.getItem('roles'));
    const accesibleDashboards = extractRoles(roles);

    const [timeFilterSelections, setTimeFilterSelections] = useState({});
    const [showFilters, setShowFilters] = useState(false);
    const [alertFilterData, alertFilterDispatch] = useReducer(alertFilterDataReducer, { clients: [] });
    const [dashboardFilterSelectionsAutomation, setdashboardFilterSelectionsAutomation] = useState({ 'franchise': [], 'client': [], 'technology': [], 'deployment_model': [], 'geo': [], "competency": [], 'priority': [], 'status': [], 'assignee': [], 'assignee_email': [], 'assigned_group': [], 'incident_status': [], 'buisness_component': [], 'automata_state': [], 'itemStatus_A1': [], 'queue_name': [], 'job_id': [], 'automata_name': [], 'automata_activity_name': [], 'resource': [], 'bot_id': [], 'assignment_group': [], 'process_name': [], "remediation_type": [] });
    const [dashboardFilterSelectionsSAP, setdashboardFilterSelectionsSAP] = useState({ 'franchise': [], 'client': [], 'priority': [], 'assigned_group': [], 'incident_status': [], 'assignment_group': [], 'bpmn_user': [], 'bpmn_report': [], 'bpmn_report_type': [], 'alert_source': [], 'alert_system_name': [] });
    const [dashboardFilterSelectionsSalesforce, setdashboardFilterSelectionsSalesforce] = useState({ 'franchise': [], 'client': [], 'priority': [], 'assigned_group': [], 'incident_status': [], 'assignment_group': [] });
    const [disabledSelects, setDisabledSelects] = useState({ 'client-select': true });
    let user = JSON.parse(localStorage.getItem('user'));
    const [userPrefs, setUserPrefs] = useState(null);
    const [showProcessOwnerDashboardList, setShowProcessOwnerDashboardList] = useState(false);
    const [showAOCCSupervisorDashboardList, setShowAOCCSupervisorDashboardList] = useState(false);
    const [showAutomationCOEDashboardList, setShowAutomationCOEDashboardList] = useState(false);
    const [isBackgroundProcessOwnerSelected, setBackgroundProcessOwner] = useState(false);
    const [isBackgroundAOCCSupervisorSelected, setBackgroundAOCCSupervisor] = useState(false);
    const [isBackgroundAutomationCOESelected, setBackgroundAutomationCOE] = useState(false);
    const [selectedDashboard, setSelectedDashboard] = useState(accesibleDashboards[0]);
    const [selectedFranchiseCount, setSelectedFranchiseCount] = useState();
    const [selectedClientCount, setSelectedClientCount] = useState();
    const [selectedTechnologyCount, setSelectedTechnologyCount] = useState();
    const [selectedDeploymentModelCount, setSelectedDeploymentModelCount] = useState();
    const [selectedGeoCount, setSelectedGeoCount] = useState();
    const [selectedCompetencyCount, setSelectedCompetencyCount] = useState();
    const [selectedPriorityCount, setSelectedPriorityCount] = useState();
    const [selectedStatusCount, setSelectedStatusCount] = useState();
    const [selectedAssigneeCount, setSelectedAssigneeCount] = useState();
    const [workspace, setWorkspace] = useState(props.workspace);
    const [preferencesChanged, setPreferencesChanged] = useState(false);
    const [selectedJobIDCount, setSelectedJobIDCount] = useState();
    const [selectedIncidentStatusCount, setSelectedIncidentStatusCount] = useState();
    const [selectedQueueNameCount, setSelectedQueueNameCount] = useState();
    const [selectedAutomataStateCount, setSelectedAutomataStateCount] = useState();
    const [selectedAssignedGroupCount, setSelectedAssignedGroupCount] = useState();
    const [selectedAssigneeEmailCount, setSelectedAssigneeEmailCount] = useState();
    const [selectedAssignmentGroupCount, setSelectedtAssignmentGroupCount] = useState();
    const [selectedAutomataActivityNameCount, setSelectedAutomataActivityNameCount] = useState();
    const [selectedAutomataNameCount, setSelectedAutomataNameCount] = useState();
    const [selectedBusinessComponentCount, setSelectedBusinessComponentCount] = useState();
    const [selectedItemStatusA1Count, setSelectedItemStatusA1Count] = useState();
    const [selectedResourceCount, setSelectedResourceCount] = useState();
    const [selectedBotIdCount, setSelectedBotIdCount] = useState();
    const [selectedProcessNameCount, setSelectedProcessNameCount] = useState();
    const [selectedKpi, setSelectedKpi] = useState(DashboardConstants.ROI);
    const [selectedProcess, setSelectedProcess] = useState([]);
    const [selectedRemediationTypeCount, setSelectedRemediationTypeCount] = useState();
    const [selectedBpmnUserCount, setSelectedBpmnUserCount] = useState();
    const [selectedBpmnReportCount, setSelectedBpmnReportCount] = useState();
    const [selectedBpmnReportTypeCount, setSelectedBpmnReportTypeCount] = useState();
    const [selectedAlertSourceCount, setSelectedAlertSourceCount] = useState();
    const [selectedAlertSystemNameCount, setSelectedAlertSystemNameCount] = useState();

    function extractRoles(roles) {

        let configToPick;
        if (config.URL.includes(config.unilever)) {
            configToPick = dashboardAccessConfigUll;
        } else {
            configToPick = dashboardAccessConfig;
        }
        let accessibleDashbords = [];
        for (let i = 0; i < roles.length; i++) {
            if (configToPick[roles[i]]) {
                accessibleDashbords.push(...configToPick[roles[i]].dashboards);
            }
        }
        return accessibleDashbords;
    };

    useEffect(() => {
        getUserPreferences(user.username);
        if (workspace === workspaces.automation_ops) {
            callGetApi(Constants.GETALERTSFILTERDATAURL, { 'Content-Type': 'application/json' })
                .then(resp => {
                    if (resp.aggregations.franchises) {
                        let franchiseList = [];
                        resp.aggregations.franchises.buckets.forEach(element => {
                            let franchise = {};
                            franchise.name = element.key;
                            franchiseList.push(franchise);
                        });
                        alertFilterDispatch({ type: "add_franchise", item: franchiseList });
                    }

                    if (resp.aggregations.technologies) {
                        let technologiesList = [];
                        resp.aggregations.technologies.buckets.forEach(element => {
                            let technology = {};
                            technology.name = element.key;
                            technologiesList.push(technology);
                        });
                        alertFilterDispatch({ type: "add_technologies", item: technologiesList });
                    }

                    if (resp.aggregations.deployment_models.buckets) {
                        let deployment_modelsList = [];
                        resp.aggregations.deployment_models.buckets.forEach(element => {
                            let deployment_model = {};
                            deployment_model.name = element.key;
                            deployment_modelsList.push(deployment_model);
                        });
                        alertFilterDispatch({ type: "add_deployment_models", item: deployment_modelsList });
                    }

                    if (resp.aggregations.geos.buckets) {
                        let geosList = [];
                        resp.aggregations.geos.buckets.forEach(element => {
                            let geo = {};
                            geo.name = element.key;
                            geosList.push(geo);
                        });
                        alertFilterDispatch({ type: "add_geos", item: geosList });
                    }

                    if (resp.aggregations.competencies.buckets) {
                        let competenciesList = [];
                        resp.aggregations.competencies.buckets.forEach(element => {
                            let competency = {};
                            competency.name = element.key;
                            competenciesList.push(competency);
                        });
                        alertFilterDispatch({ type: "add_competencies", item: competenciesList });
                    }

                    if (resp.aggregations.priorities.buckets) {
                        let prioritiesList = [];
                        resp.aggregations.priorities.buckets.forEach(element => {
                            let priority = {};
                            priority.name = element.key;
                            prioritiesList.push(priority);
                        });
                        alertFilterDispatch({ type: "add_priorities", item: prioritiesList });
                    }

                    if (resp.aggregations.assigned_to.buckets) {
                        let assignedList = [];
                        resp.aggregations.assigned_to.buckets.forEach(element => {
                            let assigned = {};
                            assigned.name = element.key;
                            assignedList.push(assigned);
                        });
                        alertFilterDispatch({ type: "add_assignee", item: assignedList });
                    }

                    if (resp.aggregations.assigned_to_user_id.buckets) {
                        let assignedEmailList = [];
                        resp.aggregations.assigned_to_user_id.buckets.forEach(element => {
                            let assignedEmail = {};
                            assignedEmail.name = element.key;
                            assignedEmailList.push(assignedEmail);
                        });
                        alertFilterDispatch({ type: "add_assignee_email", item: assignedEmailList });
                    }

                    if (resp.aggregations.automata_state.buckets) {
                        let automataStateList = [];
                        resp.aggregations.automata_state.buckets.forEach(element => {
                            let automataState = {};
                            automataState.name = element.key;
                            automataStateList.push(automataState);
                        });
                        alertFilterDispatch({ type: "add_automata_state", item: automataStateList });
                    }

                    if (resp.aggregations.busn_component_name.buckets) {
                        let busnComponentList = [];
                        resp.aggregations.busn_component_name.buckets.forEach(element => {
                            let busnComponent = {};
                            busnComponent.name = element.key;
                            busnComponentList.push(busnComponent);
                        });
                        alertFilterDispatch({ type: "add_busn_component", item: busnComponentList });
                    }

                    if (resp.aggregations.status.buckets) {
                        let statusList = [];
                        resp.aggregations.status.buckets.forEach(element => {
                            let status = {};
                            status.name = element.key;
                            statusList.push(status);
                        });
                        alertFilterDispatch({ type: "add_status", item: statusList });
                    }

                    if (resp.aggregations.automata_activity_name.buckets) {
                        let automata_nameList = [];
                        resp.aggregations.automata_activity_name.buckets.forEach(element => {
                            let automata_name = {};
                            automata_name.name = element.key;
                            automata_nameList.push(automata_name);
                        });
                        alertFilterDispatch({ type: "add_automata_activity_name", item: automata_nameList });
                    }

                    if (resp.aggregations.resource.buckets) {
                        let resourceList = [];
                        resp.aggregations.resource.buckets.forEach(element => {
                            let resource_name = {};
                            resource_name.name = element.key;
                            resourceList.push(resource_name);
                        });
                        alertFilterDispatch({ type: "add_resource", item: resourceList });
                    }
                    if (resp.aggregations.bot_id.buckets) {
                        let botIdList = [];
                        resp.aggregations.bot_id.buckets.forEach(element => {
                            let bot_id_name = {};
                            bot_id_name.name = element.key;
                            botIdList.push(bot_id_name);
                        });
                        alertFilterDispatch({ type: "add_bot_id", item: botIdList });
                    }
                    if (resp.aggregations.process_name.buckets) {
                        let processNameList = [];
                        resp.aggregations.process_name.buckets.forEach(element => {
                            let process_name_name = {};
                            process_name_name.name = element.key;
                            processNameList.push(process_name_name);
                        });
                        alertFilterDispatch({ type: "add_process_name", item: processNameList });
                    }
                    if (resp.aggregations.remediation_type.buckets) {
                        let remediationTypeList = [];
                        resp.aggregations.remediation_type.buckets.forEach(element => {
                            let remediation_type = {};
                            remediation_type.name = element.key;
                            remediationTypeList.push(remediation_type);
                        });
                        alertFilterDispatch({ type: "add_remediation_type", item: remediationTypeList });
                    }
                }).catch((error) => {
                    console.error('Error:', error);
                });
        }

        callGetApi(Constants.GETQUEUEPERFORMANCEFLTERDATA, { 'Content-Type': 'application/json' })
            .then(resp => {

                if (resp.aggregations.queue_name) {
                    let queue_nameGroups = [];
                    resp.aggregations.queue_name.buckets.forEach(element => {
                        let queue_nameGroup = {};
                        queue_nameGroup.name = element.key;
                        queue_nameGroups.push(queue_nameGroup);
                    });
                    alertFilterDispatch({ type: "add_queue_nameGroups", item: queue_nameGroups });
                }

                if (resp.aggregations.job_id) {
                    let job_idList = [];
                    resp.aggregations.job_id.buckets.forEach(element => {
                        let job_id = {};
                        job_id.name = element.key;
                        job_idList.push(job_id);
                    });
                    alertFilterDispatch({ type: "add_job_id", item: job_idList });
                }
                if (resp.aggregations.itemStatus_A1) {
                    let itemStatus_A1List = [];
                    resp.aggregations.itemStatus_A1.buckets.forEach(element => {
                        let itemStatus_A1 = {};
                        itemStatus_A1.name = element.key;
                        itemStatus_A1List.push(itemStatus_A1);
                    });
                    alertFilterDispatch({ type: "add_itemStatus_A1", item: itemStatus_A1List });
                }
                if (resp.aggregations.automata_name) {
                    let automata_name_List = [];
                    resp.aggregations.automata_name.buckets.forEach(element => {
                        let automata_name = {};
                        automata_name.name = element.key;
                        automata_name_List.push(automata_name);
                    });
                    alertFilterDispatch({ type: "add_automata_name", item: automata_name_List });
                }

            }).catch((error) => {
                console.error('Error:', error);
            });

        callGetApi(Constants.GETSERVICEINDEXFILTERDATAURL, { 'Content-Type': 'application/json' })
            .then(resp => {
                if (resp.aggregations.assignment_group) {
                    let assignmentGroups = [];
                    resp.aggregations.assignment_group.buckets.forEach(element => {
                        let assignmentGroup = {};
                        assignmentGroup.name = element.key;
                        assignmentGroups.push(assignmentGroup);
                    });
                    alertFilterDispatch({ type: "add_assignment_group", item: assignmentGroups });
                }

                if (resp.aggregations.incident_status) {
                    let incidentStatusList = [];
                    resp.aggregations.incident_status.buckets.forEach(element => {
                        let incidentStatus = {};
                        incidentStatus.name = element.key;
                        incidentStatusList.push(incidentStatus);
                    });
                    alertFilterDispatch({ type: "add_incident_status", item: incidentStatusList });
                }
                if (workspace === workspaces.sap_ops || workspace === workspaces.custom_ops) {
                    if (resp.aggregations.priorities.buckets) {
                        let prioritiesList = [];
                        resp.aggregations.priorities.buckets.forEach(element => {
                            let priority = {};
                            priority.name = element.key;
                            prioritiesList.push(priority);
                        });
                        alertFilterDispatch({ type: "add_priorities", item: prioritiesList });
                    }
                }
            }).catch((error) => {
                console.error('Error:', error);
            });

        // Sap Filters
        if (workspace === workspaces.sap_ops || workspace === workspaces.custom_ops) {
            callGetApi(Constants.GETSAPALERTSFILTERDATAURL, { 'Content-Type': 'application/json' })
                .then(resp => {
                    if (resp.aggregations.franchises) {
                        let franchiseList = [];
                        resp.aggregations.franchises.buckets.forEach(element => {
                            let franchise = {};
                            franchise.name = element.key;
                            franchiseList.push(franchise);
                        });
                        alertFilterDispatch({ type: "add_franchise", item: franchiseList });
                    }
                }).catch((error) => {
                    console.error('Error:', error);
                });

            callGetApi(Constants.GETBPMNFILTERS, { 'Content-Type': 'application/json' })
                .then(resp => {
                    if (resp) {
                        if (resp.userName) {
                            let bpmn_user_List = [];
                            resp.userName.forEach(element => {
                                let bpmn_user = {};
                                bpmn_user.name = element;
                                bpmn_user_List.push(bpmn_user);
                            });
                            alertFilterDispatch({ type: "add_bpmn_user", item: bpmn_user_List });
                        }

                        if (resp.reportName) {
                            let bpmn_report_List = [];
                            resp.reportName.forEach(element => {
                                let bpmn_report = {};
                                bpmn_report.name = element;
                                bpmn_report_List.push(bpmn_report);
                            });
                            alertFilterDispatch({ type: "add_bpmn_report", item: bpmn_report_List });
                        }

                        if (resp.reportType) {
                            let bpmn_report_type_List = [];
                            resp.reportType.forEach(element => {
                                let bpmn_report_type = {};
                                bpmn_report_type.name = element;
                                bpmn_report_type_List.push(bpmn_report_type);
                            });
                            alertFilterDispatch({ type: "add_bpmn_report_type", item: bpmn_report_type_List });
                        }
                    }
                }).catch((error) => {
                    console.error('Error:', error);
                });

        }

        if (workspace === workspaces.salesforce_ops) {
            callGetApi(Constants.GETSALESFORCEALERTSFILTERDATAURL, { 'Content-Type': 'application/json' })
                .then(resp => {
                    if (resp.aggregations.franchises) {
                        let franchiseList = [];
                        resp.aggregations.franchises.buckets.forEach(element => {
                            let franchise = {};
                            franchise.name = element.key;
                            franchiseList.push(franchise);
                        });
                        alertFilterDispatch({ type: "add_franchise", item: franchiseList });
                    }

                }).catch((error) => {
                    console.error('Error:', error);
                });
        }

    }, [workspace, props.accessibleDashboard]);

    useEffect(() => {
        if (selectedDashboard === "TrustIndex" || selectedDashboard === "Execution" || selectedDashboard === "Capacity") {
            setBackgroundAOCCSupervisor(true);
            setBackgroundProcessOwner(true);
            setBackgroundAutomationCOE(false);
        } else if (selectedDashboard === "Remediation" || selectedDashboard === "SLA" || selectedDashboard === "ProductivityMetrics" || selectedDashboard === "Buisness" || selectedDashboard === "IncidentManagement" || selectedDashboard === "AlertManagement") {
            workspace === workspaces.automation_ops && selectedDashboard === "IncidentManagement" ? setBackgroundProcessOwner(false) : setBackgroundProcessOwner(true)
            workspace === workspaces.automation_ops && selectedDashboard === "IncidentManagement" ? setBackgroundAOCCSupervisor(true) : setBackgroundAOCCSupervisor(false)
            selectedDashboard !== "IncidentManagement" && setBackgroundProcessOwner(true);
            selectedDashboard !== "IncidentManagement" && setBackgroundAOCCSupervisor(false);
            setBackgroundAutomationCOE(true);
        } else {
            setBackgroundAutomationCOE(true);
            setBackgroundAOCCSupervisor(true);
            setBackgroundProcessOwner(false);
        }
    }, [workspace]);

    const setDefaultTimeFilter = () => {
        var selections = {};
        let endMoment = moment();
        let strEndMoment = endMoment.format();
        var formatedEndDate = endMoment.format('l');
        var formattedEndTime = endMoment.format('hh:mm');
        var endAMPM = endMoment.format('A');
        let startMoment = endMoment.subtract({ hours: 24 });
        let strStartMoment = startMoment.format();
        var formatedStartDate = startMoment.format('l');
        var formattedStartTime = startMoment.format('hh:mm');
        var startAMPM = startMoment.format('A');
        selections.startDateTime = strStartMoment
        selections.startDate = formatedStartDate;
        selections.startTime = formattedStartTime;
        selections.startAMPM = startAMPM;
        selections.endDateTime = strEndMoment;
        selections.endDate = formatedEndDate;
        selections.endTime = formattedEndTime;
        selections.endAMPM = endAMPM;
        selections.timeInterval = 0;
        selections.timeRangeType = "relative";  // relative , absolute
        selections.timeRange = "1D"; // can be 15m, 30m, 1H, 1D, 7D, 1M, 3M, 6M, 1Y, WTD, MTD, YTD
        setTimeFilterSelections(selections);
    }

    const getUserPreferences = async (user) => {
        setUserPrefs(null);
        setPreferencesChanged(false);
        let body = { 'user': user };

        let response = await callPostApi(Constants.GETUSERPREFRENCESURL, {
            'Content-Type': 'application/json'
        }, body);
        let respJson = await response;
        let userPrefs = {};
        if (respJson && respJson && respJson._source) {
            if (respJson._source.timeFilters) {
                let timeFilter = respJson._source.timeFilters;

                if (respJson._source.timeFilters.timeRangeType === "relative") {
                    timeFilter = getNewTimeRange(respJson._source.timeFilters.timeRange);
                    timeFilter.timeInterval = (respJson._source.timeFilters.timeInterval);
                }
                setTimeFilterSelections(timeFilter);
            } else {
                setDefaultTimeFilter();
            }

            if (respJson._source.workspace) {
                setWorkspace(respJson._source.workspace);
            }

            if (respJson._source.dashboard && respJson._source.dashboard.dashboardFiltersAutomation) {
                userPrefs.dashboardFiltersAutomation = respJson._source.dashboard.dashboardFiltersAutomation;
                setdashboardFilterSelectionsAutomation(userPrefs.dashboardFiltersAutomation)
                if (workspace === workspaces.automation_ops) {
                    if (userPrefs.dashboardFiltersAutomation.franchise) {
                        setSelectedFranchiseCount(userPrefs.dashboardFiltersAutomation.franchise.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.client) {
                        setSelectedClientCount(userPrefs.dashboardFiltersAutomation.client.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.geo) {
                        setSelectedGeoCount(userPrefs.dashboardFiltersAutomation.geo.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.priority) {
                        setSelectedPriorityCount(userPrefs.dashboardFiltersAutomation.priority.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.competency) {
                        setSelectedCompetencyCount(userPrefs.dashboardFiltersAutomation.competency.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.technology) {
                        setSelectedTechnologyCount(userPrefs.dashboardFiltersAutomation.technology.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.deployment_model) {
                        setSelectedDeploymentModelCount(userPrefs.dashboardFiltersAutomation.deployment_model.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.assignee) {
                        setSelectedAssigneeCount(userPrefs.dashboardFiltersAutomation.assignee.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.job_id) {
                        setSelectedJobIDCount(userPrefs.dashboardFiltersAutomation.job_id.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.incident_status) {
                        setSelectedIncidentStatusCount(userPrefs.dashboardFiltersAutomation.incident_status.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.queue_name) {
                        setSelectedQueueNameCount(userPrefs.dashboardFiltersAutomation.queue_name.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.status) {
                        setSelectedStatusCount(userPrefs.dashboardFiltersAutomation.status.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.automata_state) {
                        setSelectedAutomataStateCount(userPrefs.dashboardFiltersAutomation.automata_state.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.assigned_group) {
                        setSelectedAssignedGroupCount(userPrefs.dashboardFiltersAutomation.assigned_group.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.assignee_email) {
                        setSelectedAssigneeEmailCount(userPrefs.dashboardFiltersAutomation.assignee_email.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.assignment_group) {
                        setSelectedtAssignmentGroupCount(userPrefs.dashboardFiltersAutomation.assignment_group.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.automata_name) {
                        setSelectedAutomataNameCount(userPrefs.dashboardFiltersAutomation.automata_name.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.buisness_component) {
                        setSelectedBusinessComponentCount(userPrefs.dashboardFiltersAutomation.buisness_component.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.automata_activity_name) {
                        setSelectedAutomataActivityNameCount(userPrefs.dashboardFiltersAutomation.automata_activity_name.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.itemStatus_A1) {
                        setSelectedItemStatusA1Count(userPrefs.dashboardFiltersAutomation.itemStatus_A1.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.resource) {
                        setSelectedResourceCount(userPrefs.dashboardFiltersAutomation.resource.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.bot_id) {
                        setSelectedBotIdCount(userPrefs.dashboardFiltersAutomation.bot_id.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.process_name) {
                        setSelectedProcessNameCount(userPrefs.dashboardFiltersAutomation.process_name.length);
                    }
                    if (userPrefs.dashboardFiltersAutomation.remediation_type) {
                        setSelectedRemediationTypeCount(userPrefs.dashboardFiltersAutomation.remediation_type.length);
                    }
                }
            }

            if (respJson._source.dashboard && respJson._source.dashboard.dashboardFiltersSAP) {
                userPrefs.dashboardFiltersSAP = respJson._source.dashboard.dashboardFiltersSAP;
                setdashboardFilterSelectionsSAP(userPrefs.dashboardFiltersSAP)
                if (workspace === workspaces.sap_ops || workspace === workspaces.custom_ops) {
                    if (userPrefs.dashboardFiltersSAP.franchise) {
                        setSelectedFranchiseCount(userPrefs.dashboardFiltersSAP.franchise.length);
                    }
                    if (userPrefs.dashboardFiltersSAP.client) {
                        setSelectedClientCount(userPrefs.dashboardFiltersSAP.client.length);
                    }
                    if (userPrefs.dashboardFiltersSAP.priority) {
                        setSelectedPriorityCount(userPrefs.dashboardFiltersSAP.priority.length);
                    }
                    if (userPrefs.dashboardFiltersSAP.assignment_group) {
                        setSelectedtAssignmentGroupCount(userPrefs.dashboardFiltersSAP.assignment_group.length);
                    }
                    if (userPrefs.dashboardFiltersSAP.assigned_group) {
                        setSelectedAssignedGroupCount(userPrefs.dashboardFiltersSAP.assigned_group.length);
                    }
                    if (userPrefs.dashboardFiltersSAP.incident_status) {
                        setSelectedIncidentStatusCount(userPrefs.dashboardFiltersSAP.incident_status.length);
                    }
                    if (userPrefs.dashboardFiltersSAP.bpmn_user) {
                        setSelectedBpmnUserCount(userPrefs.dashboardFiltersSAP.bpmn_user.length);
                    }
                    if (userPrefs.dashboardFiltersSAP.bpmn_report) {
                        setSelectedBpmnReportCount(userPrefs.dashboardFiltersSAP.bpmn_report.length);
                    }
                    if (userPrefs.dashboardFiltersSAP.bpmn_report_type) {
                        setSelectedBpmnReportTypeCount(userPrefs.dashboardFiltersSAP.bpmn_report_type.length);
                    }
                    if (userPrefs.dashboardFiltersSAP.alert_source) {
                        setSelectedAlertSourceCount(userPrefs.dashboardFiltersSAP.alert_source.length);
                    }
                    if (userPrefs.dashboardFiltersSAP.alert_system_name) {
                        setSelectedAlertSystemNameCount(userPrefs.dashboardFiltersSAP.alert_system_name.length);
                    }
                }
            }

            if (respJson._source.dashboard && respJson._source.dashboard.dashboardFiltersSalesforce) {
                userPrefs.dashboardFiltersSalesforce = respJson._source.dashboard.dashboardFiltersSalesforce;
                setdashboardFilterSelectionsSalesforce(userPrefs.dashboardFiltersSalesforce)
                if (workspace === workspaces.salesforce_ops) {
                    if (userPrefs.dashboardFiltersSalesforce.franchise) {
                        setSelectedFranchiseCount(userPrefs.dashboardFiltersSalesforce.franchise.length);
                    }
                    if (userPrefs.dashboardFiltersSalesforce.client) {
                        setSelectedClientCount(userPrefs.dashboardFiltersSalesforce.client.length);
                    }
                }
            }
        } else {
            setDefaultTimeFilter();
        }
        await setUserPrefs(userPrefs);
        setPreferencesChanged(true);
    }

    const updateState = (state, stateValue, type) => {
        switch (state) {
            case 'dashboardFilterSelectionsAutomation':
                setdashboardFilterSelectionsAutomation(stateValue);
                updateUserPreferences(user.username, null, stateValue, null, null);
                break;
            case 'dashboardFilterSelectionsSAP':
                setdashboardFilterSelectionsSAP(stateValue);
                updateUserPreferences(user.username, null, null, stateValue, null);
                break;
            case 'dashboardFilterSelectionsSalesforce':
                setdashboardFilterSelectionsSalesforce(stateValue);
                updateUserPreferences(user.username, null, null, null, stateValue);
                break;
            case 'timeFilterSelections':
                setTimeFilterSelections(stateValue);
                updateUserPreferences(user.username, stateValue, null, null, null);
                break;
            case 'disabledSelects':
                setDisabledSelects(stateValue);
                break;
            case 'alertFilterData_clients':
                alertFilterDispatch({ type: "add_clients", item: stateValue });
                break;
            default:
        }
    };

    const updateUserPreferences = async (user, timeFilters, dashboardFiltersAutomation, dashboardFiltersSAP, dashboardFiltersSalesforce) => {
        let body = { "user": user }; //, "timeFilters": timeFilters, "alertFilters": alertFilters, "pAlertFilters": pAlertFilters }
        let bodyJSON = {};
        bodyJSON.user = body.user;
        if (timeFilters) {
            bodyJSON.timeFilters = timeFilters;
        }

        let dashFiltersAutomation = {};
        let dashFiltersSAP = {};
        let dashFiltersSalesforce = {};

        if (dashboardFiltersAutomation && workspace === workspaces.automation_ops) {
            dashFiltersAutomation =
            {
                "dashboardFiltersAutomation": dashboardFiltersAutomation
            };
            bodyJSON.dashboard = dashFiltersAutomation;
        }
        if (dashboardFiltersSAP && (workspace === workspaces.sap_ops || workspace === workspaces.custom_ops)) {
            dashFiltersSAP =
            {
                "dashboardFiltersSAP": dashboardFiltersSAP
            };
            bodyJSON.dashboard = dashFiltersSAP;
        }
        if (dashboardFiltersSalesforce && (workspace === workspaces.salesforce_ops)) {
            dashFiltersSalesforce =
            {
                "dashboardFiltersSalesforce": dashboardFiltersSalesforce
            };
            bodyJSON.dashboard = dashFiltersSalesforce;
        }

        callPostApi(Constants.UPDATEUSERPREFRENCESURL, {
            'Content-Type': 'application/json'
        }, bodyJSON)
            .then(resp => {
                getUserPreferences(body.user);
            }).catch((error) => {
                console.error('Error:', error);
            });
    };

    function alertFilterDataReducer(state, action) {
        switch (action.type) {
            case "add_franchise":
                return { ...state, franchises: action.item };
            case "add_clients":
                return { ...state, clients: action.item };
            case "add_technologies":
                return { ...state, technologies: action.item };
            case "add_deployment_models":
                return { ...state, deployment_models: action.item };
            case "add_geos":
                return { ...state, geos: action.item };
            case "add_competencies":
                return { ...state, competencies: action.item };
            case "add_priorities":
                return { ...state, priorities: action.item };
            case "add_assignee":
                return { ...state, assignees: action.item };
            case "add_assignee_email":
                return { ...state, assignees_email: action.item };
            case "add_assignment_group":
                return { ...state, assignment_group: action.item };
            case "add_incident_status":
                return { ...state, incident_status: action.item };
            case "add_automata_state":
                return { ...state, automata_state: action.item };
            case "add_busn_component":
                return { ...state, buisness_component: action.item };
            case "add_queue_nameGroups":
                return { ...state, queue_name: action.item };
            case "add_job_id":
                return { ...state, job_id: action.item };
            case "add_itemStatus_A1":
                return { ...state, itemStatus_A1: action.item };
            case "add_status":
                return { ...state, status: action.item };
            case "add_automata_name":
                return { ...state, automata_name: action.item };
            case "add_automata_activity_name":
                return { ...state, automata_activity_name: action.item };
            case "add_resource":
                return { ...state, resource: action.item };
            case "add_bot_id":
                return { ...state, bot_id: action.item };
            case "add_process_name":
                return { ...state, process_name: action.item };
            case "add_remediation_type":
                return { ...state, remediation_type: action.item };
            case "add_bpmn_user":
                return { ...state, bpmn_user: action.item };
            case "add_bpmn_report":
                return { ...state, bpmn_report: action.item };
            case "add_bpmn_report_type":
                return { ...state, bpmn_report_type: action.item };
            case "add_alert_source":
                return { ...state, alert_source: action.item };
            case "add_alert_system_name":
                return { ...state, alert_system_name: action.item };
            default:
                return { ...state };
        }
    }

    const handleFilters = () => {
        setShowFilters(!showFilters);
        setShowAOCCSupervisorDashboardList(false);
        setShowAutomationCOEDashboardList(false);
        setShowProcessOwnerDashboardList(false);
    };

    const handleClose = () => {
        setShowFilters(!showFilters);
    }

    const changeDashboard = (type) => {
        setSelectedDashboard(type);
        setShowAOCCSupervisorDashboardList(false);
        setShowProcessOwnerDashboardList(false);
        setShowAutomationCOEDashboardList(false);
    };

    const handleProcessOwnerDashboardList = () => {
        setBackgroundProcessOwner(false);
        if (selectedDashboard === "IncidentManagement" || selectedDashboard === "QueueEfficiency" || selectedDashboard === "Bot" ||
            selectedDashboard === "SchedulingEfficiency" || selectedDashboard === "QueueManagement" || selectedDashboard === "Bpmn" || selectedDashboard === "ServiceDeskTriagePerformance" || selectedDashboard === "Processes") {
            setBackgroundAOCCSupervisor(false);
        }
        setBackgroundAOCCSupervisor(true);
        setBackgroundAutomationCOE(true);
        setShowProcessOwnerDashboardList(!showProcessOwnerDashboardList);
        setShowAOCCSupervisorDashboardList(false);
        setShowAutomationCOEDashboardList(false);
        setShowFilters(false);
    };

    const handleAOCCSupervisorDashboardList = () => {
        setBackgroundAOCCSupervisor(false);
        if (selectedDashboard === "Remediation" || selectedDashboard === "SLA" || selectedDashboard === "ProductivityMetrics" ||
            selectedDashboard === "Buisness" || selectedDashboard === "IncidentManagement" || selectedDashboard === "AlertManagement" || selectedDashboard === "UserLoginStatistics" || selectedDashboard === "BatchJobStatistics") {
            setBackgroundAOCCSupervisor(false);
        }
        setBackgroundProcessOwner(true);
        setBackgroundAutomationCOE(true);
        setShowAOCCSupervisorDashboardList(!showAOCCSupervisorDashboardList)
        setShowProcessOwnerDashboardList(false);
        setShowAutomationCOEDashboardList(false);
        setShowFilters(false);
    };

    const handleAutomationCOEDashboardList = () => {
        setBackgroundAutomationCOE(false);
        if (selectedDashboard === "TrustIndex" || selectedDashboard === "Execution" || selectedDashboard === "Capacity") {
            setBackgroundAOCCSupervisor(false);
        }
        setBackgroundAOCCSupervisor(true);
        setBackgroundProcessOwner(true);
        console.log(showAutomationCOEDashboardList, "showAutomationCOEDashboardList")
        setShowAutomationCOEDashboardList(!showAutomationCOEDashboardList);
        setShowAOCCSupervisorDashboardList(false);
        setShowProcessOwnerDashboardList(false);
        setShowFilters(false);
    };

    const getStartTime = () => {
        if (timeFilterSelections.startDateTime) {
            let startM = moment(timeFilterSelections.startDateTime);
            let startMStr = startM.locale("en").format("lll");
            return startMStr;
        }
        else {
            return "";
        }
    };

    const getEndTime = () => {
        if (timeFilterSelections.endDateTime) {
            let endM = moment(timeFilterSelections.endDateTime);
            let endMStr = endM.locale("en").format("lll");
            return endMStr;
        }
        else {
            return "";
        }
    };


    const handleFilterLabel = (type) => {
        switch (type) {
            case "Franchise":
                if (workspace === workspaces.automation_ops) {
                    updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "franchise": [], "client": [] });
                }
                if (workspace === workspaces.sap_ops || workspace === workspaces.custom_ops) {
                    updateState('dashboardFilterSelectionsSAP', { ...dashboardFilterSelectionsSAP, "franchise": [], "client": [], "alert_source": [], "alert_system_name": [] });
                }
                if (workspace === workspaces.salesforce_ops) {
                    updateState('dashboardFilterSelectionsSalesforce', { ...dashboardFilterSelectionsSalesforce, "franchise": [], "client": [] });
                }
                setShowFilters(false);
                break;
            case "Client":
                if (workspace === workspaces.automation_ops) {
                    updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "client": [] });
                }
                if (workspace === workspaces.sap_ops || workspace === workspaces.custom_ops) {
                    updateState('dashboardFilterSelectionsSAP', { ...dashboardFilterSelectionsSAP, "client": [], "alert_source": [], "alert_system_name": [] });
                }
                if (workspace === workspaces.salesforce_ops) {
                    updateState('dashboardFilterSelectionsSalesforce', { ...dashboardFilterSelectionsSalesforce, "client": [] });
                }
                setShowFilters(false);
                break;
            case "Technology":
                updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "technology": [] });
                setShowFilters(false);
                break;
            case "DeploymentModel":
                updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "deployment_model": [] });
                setShowFilters(false);
                break;
            case "Geo":
                updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, 'geo': [] });
                setShowFilters(false);
                break;
            case "Competency":
                updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "competency": [] });
                setShowFilters(false);
                break;
            case "Priority":
                if (workspace === workspaces.automation_ops) {
                    updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "priority": [] });
                }
                if (workspace === workspaces.sap_ops || workspace === workspaces.custom_ops) {
                    updateState('dashboardFilterSelectionsSAP', { ...dashboardFilterSelectionsSAP, "priority": [] });
                }
                if (workspace === workspaces.salesforce_ops) {
                    updateState('dashboardFilterSelectionsSalesforce', { ...dashboardFilterSelectionsSalesforce, "priority": [] });
                }
                setShowFilters(false);
                break;
            case "Status":
                updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "status": [] });
                setShowFilters(false);
                break;
            case "Assignee":
                updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "assignee": [] });
                setShowFilters(false);
                break;
            case "AssigneeEmail":
                updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "assignee_email": [] });
                setShowFilters(false);
                break;
            case "AssignedGroup":
                updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "assigned_group": [] });
                setShowFilters(false);
                break;
            case "AssignmentGroup":

                if (workspace === workspaces.automation_ops) {
                    updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "assignment_group": [] });
                }
                if (workspace === workspaces.sap_ops || workspace === workspaces.custom_ops) {
                    updateState('dashboardFilterSelectionsSAP', { ...dashboardFilterSelectionsSAP, "assignment_group": [] });
                }
                if (workspace === workspaces.salesforce_ops) {
                    updateState('dashboardFilterSelectionsSalesforce', { ...dashboardFilterSelectionsSalesforce, "assignment_group": [] });
                }
                setShowFilters(false);
                break;
            case "IncidentStatus":
                if (workspace === workspaces.automation_ops) {
                    updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "incident_status": [] });
                }
                if (workspace === workspaces.sap_ops || workspace === workspaces.custom_ops) {
                    updateState('dashboardFilterSelectionsSAP', { ...dashboardFilterSelectionsSAP, "incident_status": [] });
                }
                if (workspace === workspaces.salesforce_ops) {
                    updateState('dashboardFilterSelectionsSalesforce', { ...dashboardFilterSelectionsSalesforce, "incident_status": [] });
                }
                setShowFilters(false);
                break;
            case "BusinessComponent":
                updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "buisness_component": [] });
                setShowFilters(false);
                break;
            case "AutomataState":
                updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "automata_state": [] });
                setShowFilters(false);
                break;
            case "AutomataName":
                updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "automata_name": [] });
                setShowFilters(false);
                break;
            case "ItemStatusA1":
                updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "itemStatus_A1": [] });
                setShowFilters(false);
                break;
            case "JobId":
                updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "job_id": [] });
                setShowFilters(false);
                break;
            case "AutomataActivityName":
                updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "automata_activity_name": [] });
                setShowFilters(false);
                break;
            case "Resource":
                updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "resource": [] });
                setShowFilters(false);
                break;
            case "BotId":
                updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "bot_id": [] });
                setShowFilters(false);
                break;
            case "QueueName":
                updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "queue_name": [] });
                setShowFilters(false);
                break;
            case "ProcessName":
                updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "process_name": [] });
                setShowFilters(false);
                break;
            case "RemediationType":
                updateState('dashboardFilterSelectionsAutomation', { ...dashboardFilterSelectionsAutomation, "remediation_type": [] });
                setShowFilters(false);
                break;
            case "BpmnUser":
                updateState('dashboardFilterSelectionsSAP', { ...dashboardFilterSelectionsSAP, "bpmn_user": [] });
                setShowFilters(false);
                break;
            case "BpmnReport":
                updateState('dashboardFilterSelectionsSAP', { ...dashboardFilterSelectionsSAP, "bpmn_report": [] });
                setShowFilters(false);
                break;
            case "BpmnReportType":
                updateState('dashboardFilterSelectionsSAP', { ...dashboardFilterSelectionsSAP, "bpmn_report_type": [] });
                setShowFilters(false);
                break;
            case "AlertSource":
                updateState('dashboardFilterSelectionsSAP', { ...dashboardFilterSelectionsSAP, "alert_source": [] });
                setShowFilters(false);
                break;
            case "AlertSystemName":
                updateState('dashboardFilterSelectionsSAP', { ...dashboardFilterSelectionsSAP, "alert_system_name": [] });
                setShowFilters(false);
                break;
            default:
        }
    };

    function handleItemClick(item) {
        setSelectedKpi(item);
        setShowFilters(false);
    }

    function handleSelectedProcess(item) {
        setSelectedProcess(item);
    }

    const renderTimeFilter = useMemo(() => {
        return <TimeFilter updateState={updateState} timeFilterSelections={timeFilterSelections}></TimeFilter>
    }, [timeFilterSelections])

    return (
        <div className="dashboard-header-panel-new">
            <div className="header">
                {workspace === workspaces.automation_ops || workspace === workspaces.sap_ops || workspace === workspaces.salesforce_ops ?
                    <div className="breadcrumb">
                        <Breadcrumb aria-label="Page navigation">
                            <BreadcrumbItem href='/homepage'>
                                {DashboardConstants.home}
                            </BreadcrumbItem>
                        </Breadcrumb>
                        <div className="title">
                            {DashboardConstants.Analytics}
                        </div>
                    </div> : null}
            </div>
            <div className="container-panel">
                <div className={"role-container"}>
                    <Row style={{ gap: '10px' }} className="role-panels">
                        <div xs className="role-tiles bx--col-lg-4" >
                            <div className="role">
                                <div className={"name-container"}>
                                    <div className='icon' > <User32 /></div>
                                    <Navbar collapseOnSelect expand="sm">
                                        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                                        <Navbar.Collapse id="responsive-navbar-nav">
                                            <Nav>
                                                <Nav.Item><HeaderTiles accesibleDashboards={accesibleDashboards} handleAOCCSupervisorDashboardList={handleAOCCSupervisorDashboardList} workspace={props.workspace} isBackgroundAOCCSupervisorSelected={isBackgroundAOCCSupervisorSelected} showAOCCSupervisorDashboardList={showAOCCSupervisorDashboardList} setShowAOCCSupervisorDashboardList={setShowAOCCSupervisorDashboardList} changeDashboard={changeDashboard} selectedDashboard={selectedDashboard} type={"Supervisor"} /></Nav.Item>
                                                <Nav.Item><HeaderTiles accesibleDashboards={accesibleDashboards} handleProcessOwnerDashboardList={handleProcessOwnerDashboardList} workspace={props.workspace} isBackgroundProcessOwnerSelected={isBackgroundProcessOwnerSelected} showProcessOwnerDashboardList={showProcessOwnerDashboardList} setShowProcessOwnerDashboardList={setShowProcessOwnerDashboardList} changeDashboard={changeDashboard} selectedDashboard={selectedDashboard} type={"ProcessOwner"} /></Nav.Item>
                                                <Nav.Item><HeaderTiles accesibleDashboards={accesibleDashboards} handleAutomationCOEDashboardList={handleAutomationCOEDashboardList} workspace={props.workspace} isBackgroundAutomationCOESelected={isBackgroundAutomationCOESelected} showAutomationCOEDashboardList={showAutomationCOEDashboardList} setShowAutomationCOEDashboardList={setShowAutomationCOEDashboardList} changeDashboard={changeDashboard} selectedDashboard={selectedDashboard} type={"AutomationCoE"} /></Nav.Item>
                                            </Nav>
                                        </Navbar.Collapse>
                                    </Navbar>
                                </div>
                            </div>
                        </div>
                        <div className='time-filter-group bx--col-lg-8'>
                            <div className="time-filter-container">
                                <div className="time startTime carbon-display-Regular-14">{getStartTime()}</div>
                                <div className="hyphen">{`\u00A0 - \u00A0`}</div>
                                <div className="time endTime carbon-display-Regular-14">{getEndTime()}</div>
                                <div className="time-filter-button" >
                                    {renderTimeFilter}
                                </div>
                            </div>

                            {/* <SlidingPane from='right' className="slide-pane" onRequestClose={() => setShowFilters((prev) => !prev)} width="100%" hideHeader={false} overlayClassName="some-custom-overlay-class"
                                isOpen={showFilters} closeIcon={<Close32 />} shouldCloseOnEsc={true}
                            //title="Hey, it is optional pane title.  I can be React component too."  //subtitle="Optional subtitle."
                            >
                         <div>Filters</div>
                            <DashboardFilters alertType={"reactive"} filterData={alertFilterData} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP}
                                disabledSelects={disabledSelects} handleClose={handleClose} updateState={updateState} dashboardType={selectedDashboard} workspace={workspace} />
                        </SlidingPane> */}

                            {<OutsideClickHandler onOutsideClick={() => { setShowFilters(false); }}>
                                {<div className={"filter-container"}>
                                    <Button kind="tertiary" iconDescription='Filters' onClick={handleFilters} renderIcon={FilterEdit32}>{DashboardConstants.Filters}</Button>
                                </div>}
                                <SlidingPanel backdropClicked={handleClose} type="top" isOpen={showFilters} panelClassName="additional-class" noBackdrop={true} size="10" >
                                    <div className='panel-container filter-panel'>
                                        <div className="close-button" >
                                            <Button kind='ghost' renderIcon={Close32} hasIconOnly iconDescription='Close' onClick={() => handleClose()} tooltipPosition="bottom" />
                                        </div>
                                        {selectedDashboard !== "AutomationBusinessCatalogue" ?
                                            <DashboardFilters alertType={"reactive"} filterData={alertFilterData} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} filterSelectionsSalesforce={dashboardFilterSelectionsSalesforce}
                                                handleClose={handleClose} updateState={updateState} dashboardType={selectedDashboard} workspace={workspace} />
                                            : <div><Tabs>
                                                <Tab label="Filters">
                                                    <div><DashboardFilters alertType={"reactive"} filterData={alertFilterData} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} filterSelectionsSalesforce={dashboardFilterSelectionsSalesforce}
                                                        handleClose={handleClose} updateState={updateState} dashboardType={selectedDashboard} workspace={workspace} />
                                                    </div>
                                                </Tab>
                                                <Tab label="Lens" className='lens'>
                                                    <Lens selectedDashboard={selectedDashboard} handleItemClick={handleItemClick} selectedKpi={selectedKpi} />
                                                </Tab>
                                            </Tabs></div>}
                                    </div>
                                </SlidingPanel>
                            </OutsideClickHandler>}
                        </div>

                    </Row>
                </div>
                <div className='stats-container' >
                    {selectedFranchiseCount > 0 || selectedClientCount > 0 || selectedGeoCount > 0 || selectedTechnologyCount > 0 || selectedDeploymentModelCount > 0 || selectedCompetencyCount > 0 || selectedPriorityCount > 0 ||
                        selectedAssigneeCount > 0 || selectedJobIDCount > 0 || selectedStatusCount > 0 || selectedIncidentStatusCount > 0 || selectedQueueNameCount > 0 || selectedAutomataStateCount > 0 || selectedAutomataStateCount > 0 ||
                        selectedAssignedGroupCount > 0 || selectedAutomataActivityNameCount > 0 || selectedAutomataNameCount > 0 || selectedBusinessComponentCount > 0 || selectedItemStatusA1Count > 0 || selectedResourceCount > 0 || selectedBotIdCount > 0 ||
                        selectedAssignmentGroupCount > 0 || selectedProcessNameCount > 0 || selectedRemediationTypeCount > 0 || selectedBpmnUserCount > 0 || selectedBpmnReportCount > 0 || selectedBpmnReportTypeCount > 0 ||
                        selectedAlertSourceCount > 0 || selectedAlertSystemNameCount > 0
                        ?
                        workspace === workspaces.sap_ops || workspace === workspaces.automation_ops || workspace === workspaces.custom_ops || workspace === workspaces.salesforce_ops ?
                            <div className="stats">
                                <div className="stats-label">{DashboardConstants.ShowingStatsFor}</div>
                                {selectedFranchiseCount > 0 ?
                                    <div className="stats-color"><Tag type="blue">{selectedFranchiseCount} {DashboardConstants.franchise}<Close32 onClick={() => handleFilterLabel('Franchise')} /></Tag></div> : null}
                                {selectedClientCount > 0 ?
                                    <div className="stats-color"><Tag type="blue">{selectedClientCount} {DashboardConstants.Client}<Close32 onClick={() => handleFilterLabel('Client')} /></Tag> </div> : null}
                                {selectedAssigneeCount > 0 ?
                                    <div className="stats-color"><Tag type="blue">{selectedAssigneeCount} {DashboardConstants.Assignee}<Close32 onClick={() => handleFilterLabel('Assignee')} /></Tag></div> : null}
                                {selectedTechnologyCount > 0 ?
                                    <div className="stats-color"> <Tag type="blue">{selectedTechnologyCount} {DashboardConstants.Technology}<Close32 onClick={() => handleFilterLabel('Technology')} /></Tag></div> : null}
                                {selectedDeploymentModelCount > 0 ?
                                    <div className="stats-color"><Tag type="blue">{selectedDeploymentModelCount} {DashboardConstants.DeploymentModel}<Close32 onClick={() => handleFilterLabel('DeploymentModel')} /></Tag></div> : null}
                                {selectedGeoCount > 0 ?
                                    <div className="stats-color"><Tag type="blue">{selectedGeoCount} {DashboardConstants.Geo}<Close32 onClick={() => handleFilterLabel('Geo')} /></Tag></div> : null}
                                {selectedPriorityCount > 0 ?
                                    <div className="stats-color"><Tag type="blue">{selectedPriorityCount} {DashboardConstants.FilterPriority}<Close32 onClick={() => handleFilterLabel('Priority')} /></Tag></div> : null}
                                {selectedJobIDCount > 0 ?
                                    <div className="stats-color"><Tag type="blue">{selectedJobIDCount} {DashboardConstants.JobId}<Close32 onClick={() => handleFilterLabel('JobId')} /></Tag></div> : null}
                                {selectedStatusCount > 0 ?
                                    <div className="stats-color"><Tag type="blue">{selectedStatusCount} {DashboardConstants.Status}<Close32 onClick={() => handleFilterLabel('Status')} /></Tag></div> : null}
                                {selectedCompetencyCount > 0 ?
                                    <div className="stats-color"><Tag type="blue">{selectedCompetencyCount} {config.URL.includes(config.unilever) ? DashboardConstants.LeadPlatform : DashboardConstants.Competency}<Close32 onClick={() => handleFilterLabel('Competency')} /></Tag></div> : null}
                                {selectedIncidentStatusCount > 0 ?
                                    <div className="stats-color"><Tag type="blue">{selectedIncidentStatusCount} {DashboardConstants.FilterIncidentStatus}<Close32 onClick={() => handleFilterLabel('IncidentStatus')} /></Tag></div> : null}
                                {selectedQueueNameCount > 0 ?
                                    <div className="stats-color"><Tag type="blue">{selectedQueueNameCount} {DashboardConstants.QueueName}<Close32 onClick={() => handleFilterLabel('QueueName')} /></Tag></div> : null}
                                {selectedAutomataStateCount > 0 ?
                                    <div className="stats-color"><Tag type="blue">{selectedAutomataStateCount} {DashboardConstants.AutomataState}<Close32 onClick={() => handleFilterLabel('AutomataState')} /></Tag></div> : null}
                                {selectedAssignedGroupCount > 0 ?
                                    <div className="stats-color"><Tag type="blue">{selectedAssignedGroupCount} {DashboardConstants.AssignedGroup}<Close32 onClick={() => handleFilterLabel('AssignedGroup')} /></Tag></div> : null}
                                {selectedAssigneeEmailCount > 0 ?
                                    <div className="stats-color"><Tag type="blue">{selectedAssigneeEmailCount} {DashboardConstants.AssigneeEmail}<Close32 onClick={() => handleFilterLabel('AssignedEmail')} /></Tag></div> : null}
                                {selectedAssignmentGroupCount > 0 ?
                                    <div className="stats-color"><Tag type="blue">{selectedAssignmentGroupCount} {DashboardConstants.AssignmentGp}<Close32 onClick={() => handleFilterLabel('AssignmentGroup')} /></Tag></div> : null}
                                {selectedAutomataNameCount > 0 ?
                                    <div className="stats-color"><Tag type="blue">{selectedAutomataNameCount} {DashboardConstants.AutomataName}<Close32 onClick={() => handleFilterLabel('AutomataName')} /></Tag></div> : null}
                                {selectedAutomataActivityNameCount > 0 ?
                                    <div className="stats-color"><Tag type="blue">{selectedAutomataActivityNameCount} {config.URL.includes(config.unilever) ? DashboardConstants.BotName : DashboardConstants.AutomataName} <Close32 onClick={() => handleFilterLabel('AutomataActivityName')} /></Tag></div> : null}
                                {selectedBusinessComponentCount > 0 ?
                                    <div className="stats-color"><Tag type="blue">{selectedBusinessComponentCount} {config.URL.includes(config.unilever) ? DashboardConstants.SubArea : DashboardConstants.BusinessComponent}<Close32 onClick={() => handleFilterLabel('BusinessComponent')} /></Tag></div> : null}
                                {selectedItemStatusA1Count > 0 ?
                                    <div className="stats-color"><Tag type="blue">{selectedItemStatusA1Count} {DashboardConstants.ItemStatusA1}<Close32 onClick={() => handleFilterLabel('ItemStatusA1')} /></Tag></div> : null}
                                {selectedResourceCount > 0 ?
                                    <div className="stats-color"><Tag type="blue">{selectedResourceCount} {DashboardConstants.Resource}<Close32 onClick={() => handleFilterLabel('Resource')} /></Tag></div> : null}
                                {selectedBotIdCount > 0 ?
                                    <div className="stats-color"><Tag type="blue">{selectedBotIdCount} {DashboardConstants.BotID}<Close32 onClick={() => handleFilterLabel('BotId')} /></Tag></div> : null}
                                {selectedProcessNameCount > 0 ?
                                    <div className="stats-color"><Tag type="blue">{selectedProcessNameCount} {DashboardConstants.ProcessName}<Close32 onClick={() => handleFilterLabel('ProcessName')} /></Tag></div> : null}
                                {selectedRemediationTypeCount > 0 ?
                                    <div className="stats-color"><Tag type="blue">{selectedRemediationTypeCount} {DashboardConstants.RemediationType}<Close32 onClick={() => handleFilterLabel('RemediationType')} /></Tag></div> : null}
                                {selectedBpmnUserCount > 0 ?
                                    <div className="stats-color"><Tag type="blue">{selectedBpmnUserCount} {DashboardConstants.BpmnUser}<Close32 onClick={() => handleFilterLabel('BpmnUser')} /></Tag></div> : null}
                                {selectedBpmnReportCount > 0 ?
                                    <div className="stats-color"><Tag type="blue">{selectedBpmnReportCount} {DashboardConstants.BpmnReport}<Close32 onClick={() => handleFilterLabel('BpmnReport')} /></Tag></div> : null}
                                {selectedBpmnReportTypeCount > 0 ?
                                    <div className="stats-color"><Tag type="blue">{selectedBpmnReportTypeCount} {DashboardConstants.BpmnReportType}<Close32 onClick={() => handleFilterLabel('BpmnReportType')} /></Tag></div> : null}
                                {selectedAlertSourceCount > 0 ?
                                    <div className="stats-color"><Tag type="blue">{selectedAlertSourceCount} {DashboardConstants.AlertSource}<Close32 onClick={() => handleFilterLabel('AlertSource')} /></Tag></div> : null}
                                {selectedAlertSystemNameCount > 0 ?
                                    <div className="stats-color"><Tag type="blue">{selectedAlertSystemNameCount} {DashboardConstants.SystemName}<Close32 onClick={() => handleFilterLabel('AlertSystemName')} /></Tag></div> : null}
                            </div> : null
                        : null}
                </div>
                {preferencesChanged ?
                    <div>
                        {selectedDashboard === 'Execution' ?
                            <div><ExecutionPerformance preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} filterSelectionsSalesforce={dashboardFilterSelectionsSalesforce} workspace={workspace} /></div> : null}
                        {selectedDashboard === 'IncidentManagement' ?
                            <div><IncidentManagement preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} filterSelectionsSalesforce={dashboardFilterSelectionsSalesforce} workspace={workspace} /></div> : null}
                        {selectedDashboard === 'QueueEfficiency' ?
                            <div><QueueEfficiency preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} filterSelectionsSalesforce={dashboardFilterSelectionsSalesforce} workspace={workspace} /></div> : null}
                        {selectedDashboard === 'SLA' ?
                            <div><SLACompliance preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} filterSelectionsSalesforce={dashboardFilterSelectionsSalesforce} workspace={workspace} /></div> : null}
                        {selectedDashboard === 'AlertManagement' ?
                            <div><AlertManagement preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} filterSelectionsSalesforce={dashboardFilterSelectionsSalesforce} workspace={workspace} /></div> : null}
                        {selectedDashboard === 'QueueManagement' ?
                            <div><QueueManagement preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} filterSelectionsSalesforce={dashboardFilterSelectionsSalesforce} workspace={workspace} /></div> : null}
                        {selectedDashboard === 'Capacity' ?
                            <div> {config.URL.includes(config.unilever) ? <div><UllCapacityManagement preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} filterSelectionsSalesforce={dashboardFilterSelectionsSalesforce} workspace={workspace} /></div>
                                : <div><CapacityManagement preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} filterSelectionsSalesforce={dashboardFilterSelectionsSalesforce} workspace={workspace} /></div>}</div> : null}
                        {selectedDashboard === 'Remediation' ?
                            <div><Remediation preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} filterSelectionsSalesforce={dashboardFilterSelectionsSalesforce} workspace={workspace} /></div> : null}
                        {selectedDashboard === 'Bot' ?
                            <div> {config.URL.includes(config.unilever) ? <div><BotPerformanceULL preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} filterSelectionsSalesforce={dashboardFilterSelectionsSalesforce} workspace={workspace} /></div>
                                : <div><BotPerformance preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} filterSelectionsSalesforce={dashboardFilterSelectionsSalesforce} workspace={workspace} /></div>}</div> : null}
                        {selectedDashboard === 'SchedulingEfficiency' ?
                            <div> {config.URL.includes(config.unilever) ? <div><AutomationSchedulingEfficiency timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} filterSelectionsSalesforce={dashboardFilterSelectionsSalesforce} workspace={workspace} /></div>
                                : <div><SchedulingEfficiency preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} filterSelectionsSalesforce={dashboardFilterSelectionsSalesforce} workspace={workspace} /></div>}</div> : null}
                        {selectedDashboard === 'TrustIndex' ?
                            <div> {config.URL.includes(config.unilever) ? <div><ULLAutomationTrustIndex preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} filterSelectionsSalesforce={dashboardFilterSelectionsSalesforce} workspace={workspace} /></div> :
                                <div><AutomationTrustIndex preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} filterSelectionsSalesforce={dashboardFilterSelectionsSalesforce} workspace={workspace} /></div>}</div> : null}
                        {selectedDashboard === 'ProductivityMetrics' ?
                            <div><ProductivityMetrics preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} filterSelectionsSalesforce={dashboardFilterSelectionsSalesforce} workspace={workspace} /></div> : null}
                        {selectedDashboard === 'ServiceDeskTriagePerformance' ?
                            <div><Juniper preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} filterSelectionsSalesforce={dashboardFilterSelectionsSalesforce} workspace={workspace} /></div> : null}
                        {selectedDashboard === 'BusinessViewValueRealization' ?
                            <div><BusinessViewValueRealization preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} filterSelectionsSalesforce={dashboardFilterSelectionsSalesforce} workspace={workspace} /></div> : null}
                        {selectedDashboard === 'Bpmn' ?
                            <div><BpmnDiagram preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} filterSelectionsSalesforce={dashboardFilterSelectionsSalesforce} workspace={workspace} /></div> : null}
                        {selectedDashboard === 'AutomationBusinessCatalogue' ?
                            <div><AutomationBusiness preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} filterSelectionsSalesforce={dashboardFilterSelectionsSalesforce} workspace={workspace} selectedKpi={selectedKpi} /></div> : null}
                        {selectedDashboard === 'UsageStats' ?
                            <div><UsageStats preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} filterSelectionsSalesforce={dashboardFilterSelectionsSalesforce} workspace={workspace} selectedKpi={selectedKpi} /></div> : null}
                        {selectedDashboard === 'Processes' ?
                            <div><Processes preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} filterSelectionsSalesforce={dashboardFilterSelectionsSalesforce} workspace={workspace} handleSelectedProcess={handleSelectedProcess} selectedProcess={selectedProcess} /></div> : null}
                        {selectedDashboard === 'UserLoginStatistics' ?
                            <div><UserLoginStatistics preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} filterSelectionsSalesforce={dashboardFilterSelectionsSalesforce} workspace={workspace} /></div> : null}
                        {selectedDashboard === 'BatchJobStatistics' ?
                            <div><BatchJobStatistics preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} filterSelectionsSalesforce={dashboardFilterSelectionsSalesforce} workspace={workspace} /></div> : null}
                        {selectedDashboard === 'IntegrationStatistics' ?
                            <div><IntegrationStatistics preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} filterSelectionsSalesforce={dashboardFilterSelectionsSalesforce} workspace={workspace} /></div> : null}
                        {selectedDashboard === 'AbandonedProcesses' ?
                            <div><AbandonedProcesses preferencesChanged={preferencesChanged} timeFilterSelections={timeFilterSelections} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} filterSelectionsSalesforce={dashboardFilterSelectionsSalesforce} workspace={workspace} /></div> : null}
                    </div>
                    :
                    <div></div>
                }
            </div>
        </div>
    );
};


export default HeaderPanel;
